
  function langPos(){
    if(window.innerWidth < 767){
      var h = $('.site-header').height();
    }else{
      var h = $('.normal-header').height();
    }
    
    if(window.scrollY != 0 ){
      if(window.innerWidth < 767){
        h = (h) + 'px';
      }else{
        if($('.header-fixed').length){
          h = $('.header-fixed').height();
        }
        h = (h) + 'px';
      }     
    }else{
      var h = $('.normal-header').height();
    }
    $('.ly-switcher-wrapper').css('top',h);
  }
  $(window).scroll(function(){
    langPos();
  });
  if($('.ly-switcher-wrapper')){
    var x = setInterval(function(){
      if($('.ly-switcher-wrapper').length){
        langPos();
        clearInterval(x);
      }
    });
  }


(function () {
  const questionBlocks = document.querySelectorAll(
    'script[data-faq-questions]'
  );

  if (!questionBlocks.length) return;

  const allQuestions = [];

  questionBlocks.forEach(block => {
    try {
      const questions = JSON.parse(block.textContent);
      if (Array.isArray(questions)) {
        allQuestions.push(...questions);
      }
    } catch (e) {}
  });

  if (!allQuestions.length) return;

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": allQuestions
  };

  const schemaScript = document.createElement('script');
  schemaScript.type = 'application/ld+json';
  schemaScript.textContent = JSON.stringify(faqSchema);
  document.head.appendChild(schemaScript);
})();

(function () {
  const blocks = document.querySelectorAll(
    'script[type="application/json"][data-products-list]'
  );

  if (!blocks.length) return;

  let items = [];

  blocks.forEach(block => {
    try {
      const list = JSON.parse(block.textContent);
      if (Array.isArray(list)) {
        items.push(...list);
      }
    } catch (e) {}
  });

  if (!items.length) return;

  // OPTIONAL: deduplicate by product URL
  const seen = new Set();
  items = items.filter(item => {
    const url = item?.item?.url;
    if (!url || seen.has(url)) return false;
    seen.add(url);
    return true;
  });

  // Reassign positions globally
  items.forEach((item, index) => {
    item.position = index + 1;
  });

  const itemListSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": items
  };

  const ldScript = document.createElement('script');
  ldScript.type = 'application/ld+json';
  ldScript.textContent = JSON.stringify(itemListSchema);
  document.head.appendChild(ldScript);
})();

const backToTop = document.getElementById('backToTop');
window.addEventListener('scroll', () => {
  backToTop.style.display = window.scrollY > 300 ? 'flex' : 'none';
});

backToTop.addEventListener('click', () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
});